import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { DownloadScoredFilePayload } from 'features/Yucollect/Score/types/Score.types';

export interface DownloadScoredFileState {
  loadingId: string | null;
  error: string | null;
}

export const downloadScoredFileInitialState: DownloadScoredFileState = {
  loadingId: null,
  error: null,
};

const downloadScoredFileSlice = createSlice({
  name: 'downloadScoredFile',
  initialState: downloadScoredFileInitialState,
  reducers: {
    downloadScoredFileReq(
      state,
      action: PayloadAction<DownloadScoredFilePayload>
    ) {
      state.loadingId = action.payload.allocationId;
      state.error = null;
    },
    downloadScoredFileSuccess(state) {
      state.loadingId = null;
      state.error = null;
    },
    downloadScoredFileFailure(state, action: PayloadAction<string>) {
      state.loadingId = null;
      state.error = action.payload;
    },
    resetDownloadScoredFile: () => downloadScoredFileInitialState,
  },
});

export const {
  downloadScoredFileReq,
  downloadScoredFileSuccess,
  downloadScoredFileFailure,
  resetDownloadScoredFile,
} = downloadScoredFileSlice.actions;

export default downloadScoredFileSlice.reducer;
